// extracted by mini-css-extract-plugin
export default {"sectionTitleHighlight":"Home_sectionTitleHighlight__hpVEd"};